import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CardIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Card",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M9.42 26.54c-.59 0-1.18-.16-1.71-.46-.79-.46-1.36-1.2-1.6-2.08L1.97 8.54c-.49-1.83.6-3.71 2.42-4.2l8.84-2.37c1.83-.49 3.71.6 4.2 2.43l4.14 15.45c.24.88.12 1.81-.34 2.6s-1.2 1.36-2.08 1.6l-8.83 2.37c-.3.08-.6.12-.89.12ZM4.99 6.55c-.61.16-.97.79-.81 1.4L8.32 23.4c.08.29.27.54.53.69s.57.19.87.11l8.83-2.37c.29-.08.54-.27.69-.53s.19-.57.11-.87L15.21 4.98c-.16-.61-.79-.97-1.4-.81L4.98 6.54Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.75 29.27c-.3 0-.6-.04-.89-.12l-2.15-.58c-.61-.16-.97-.79-.81-1.4s.79-.97 1.4-.81l2.15.58c.29.08.6.04.87-.11.26-.15.45-.4.53-.69l4.14-15.46c.08-.29.04-.6-.11-.87-.15-.26-.4-.45-.69-.53L21.1 7.92c-.61-.16-.97-.79-.81-1.4s.79-.97 1.4-.81l5.09 1.36c.88.24 1.62.8 2.08 1.6.46.79.58 1.72.34 2.6l-4.14 15.46c-.24.88-.8 1.62-1.6 2.08-.53.3-1.11.46-1.71.46"
    })]
  }));
};